/* V2 */
import * as React from "react"
import {map as _map} from "lodash"

export interface HorizontalTagsListViewProps {
    tagsStringArray: string[];
    onTagRemove?: (index: number) => void;
}

const HorizontalTagsListView: React.StatelessComponent<HorizontalTagsListViewProps> = (props: HorizontalTagsListViewProps) => {
    return (
        <div>
            {
                _map(props.tagsStringArray, (tag: string, index: number) => {
                    return (
                        <span key={index}
                            className="badge oval-tag">
                            {tag}
                            <span className={"glyphicon glyphicon-remove"} onClick={() => props.onTagRemove(index)} />
                        </span>
                    );
                })
            }
        </div>
    );
};

export default HorizontalTagsListView;